import { useEffect, useState } from 'react'
import { Dialog, DialogContent, DialogHeader, DialogFooter, Input, Button } from '@you/ui'

export type UpdateDialogEntity = 'organization' | 'department'

interface UpdateDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  /** 组织结构 或 部门 */
  entity: UpdateDialogEntity
  /** 编辑时的主键ID，可为空表示新增 */
  id?: string
  /** 初始名称 */
  initialName?: string
  /** 对于部门：父ID（新增子级时需要），第一级传 '0' */
  parentId?: string
  /** 对于部门：组织ID（teamId） */
  teamId?: string
  /** 对于组织：工作空间ID */
  workspaceId?: string
  /** 确认按钮加载态 */
  loading?: boolean
  /** 提交回调，仅返回名称字符串；其余上下文字段由调用方决定 */
  onSubmit: (payload: { id?: string; name: string; parentId?: string; teamId?: string; workspaceId?: string }) => Promise<void> | void
}

const UpdateDialog = (props: UpdateDialogProps) => {
  const {
    open,
    onOpenChange,
    entity,
    id,
    initialName = '',
    parentId,
    teamId,
    workspaceId,
    loading,
    onSubmit,
  } = props

  const [name, setName] = useState(initialName)

  useEffect(() => {
    setName(initialName)
  }, [initialName, open])

  const title = id
    ? entity === 'organization'
      ? '编辑组织结构'
      : '编辑部门'
    : entity === 'organization'
      ? '新建组织结构'
      : '新建部门'

  const handleConfirm = async () => {
    if (!name.trim()) return
    await onSubmit({ id, name: name.trim(), parentId, teamId, workspaceId })
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader title={title} />
        <div className="px-6 py-4">
          <div className="space-y-4">
            <div>
              <label htmlFor="entityName" className="block text-sm font-medium text-gray-700 mb-2">
                名称 <span className="text-red-500">*</span>
              </label>
              <Input
                id="entityName"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder={entity === 'organization' ? '请输入组织名称' : '请输入部门名称'}
                className="w-full"
              />
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button variant="secondary" onClick={() => onOpenChange(false)} disabled={!!loading}>
            取消
          </Button>
          <Button onClick={handleConfirm} disabled={!name.trim() || !!loading}>
            {loading ? '保存中...' : '保存'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default UpdateDialog


